module.exports = __webpack_public_path__ + "static/media/audio-wave.422bbb02.gif";